export default {
  detailsData: (state) => state.actionDetails.data,
};
